import { useIntl } from "react-intl";
import { CellLinks, CellTags, UserCell } from "src/app/components";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import moment from "moment";
import { columnParForDates } from "src/app/components/grid/GridHelpers";

export default function usePublishGridColumns() {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "id",
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            headerName: "id",
            minWidth: 60,
            maxWidth: 60,
            hide: true,
        },
        {
            field: "publishedAt",
            headerName: formatMessage({ id: "content.grid.col.publishedAt" }),
            cellClassRules: {
                "order-fail": ({ data }: any) =>
                    moment(data.publishedAt).unix() <= moment().subtract(1, "d").unix(),
            },
            ...columnParForDates("publishedAt"),
            minWidth: 100,
            maxWidth: 100,
        },
        {
            field: "manager",
            filter: "agSetColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.manager" }),
            valueGetter: ({ data }: any) => (data?.manager ? data.manager : ""),
            cellRenderer: ({ data }: any) => <UserCell user={data.manager} />,
            autoHeight: true,
            minWidth: 60,
            maxWidth: 60,
        },
        {
            field: "moneySite",
            filter: "agSetColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.moneySite" }),
            valueGetter: ({ data }) =>
                data?.platform
                    ? data?.platform
                    : data?.moneySite
                    ? `${data?.moneySite} (${data?.pbnMoneySite})`
                    : "N/A",
            minWidth: 200,
            maxWidth: 200,
        },
        {
            field: "rd",
            filter: "agSetColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.publishedOn" }),
        },
        {
            field: "pbnRd",
            headerName: formatMessage({ id: "content.grid.col.network" }),
            filter: "agSetColumnFilter",
            valueGetter: ({ data }: any) => data.pbnRd,
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "processedAt",
            headerName: formatMessage({ id: "content.grid.col.processedAt" }),
            cellClassRules: {
                "order-fail": ({ data }: any) =>
                    moment(data.publishedAt).unix() <= moment().subtract(1, "d").unix(),
            },
            ...columnParForDates("processedAt"),
            minWidth: 100,
            maxWidth: 100,
            hide: true,
        },
        {
            field: "orderPrice",
            headerName: formatMessage({
                id: "content.grid.col.price",
            }),
            valueGetter: ({ data }: any) => `${data.orderPrice??0} €`,
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 60,
            maxWidth: 60,
        },
        {
            field: "contentType",
            headerName: formatMessage({ id: "content.grid.col.contentType" }),
            filter: "agSetColumnFilter",
            valueGetter: ({ data }: any) =>
                `${formatMessage({
                    id: `content.grid.col.contentType.${data.contentType}`,
                })} ${formatMessage({
                    id: `content.grid.col.writingType.${data.writingType}`,
                })}`,
            minWidth: 100,
            maxWidth: 100,
        },
        {
            field: "category",
            headerName: formatMessage({ id: "content.grid.col.category" }),
            filter: "agTextColumnFilter",
            cellClassRules: {
                "order-warn": ({ data }: any) => !data.category,
            },
        },
        {
            field: "keywords",
            filter: "agTextColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => data?.keywords,
            cellRenderer: ({ data }: any) => <CellTags tags={[data?.keywords]} />,
            autoHeight: true,
            width: 200,
        },
        {
            field: "links",
            autoHeight: true,
            filter: "agTextColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.links" }),
            valueGetter: ({ data }: any) =>
                data?.links
                    ? data.links[1]
                        ? `${data.links[0].url} (${data.links[0].anchor})\n ${data.links[1].url} (${data.links[1].anchor})`
                        : `${data.links[0].url} (${data.links[0].anchor})`
                    : "",
            cellRenderer: ({ data }: any) => <CellLinks links={data.links} />,
        },
        {
            field: "title",
            filter: "agTextColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.title" }),
            hide: true,
        },
        {
            field: "commentForLinker",
            filter: "agTextColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.commentForLinker" }),
            hide: true,
        },
        {
            field: "createdAt",
            headerName: formatMessage({ id: "content.grid.col.createdAt" }),
            ...columnParForDates("createdAt"),
            hide: true,
            minWidth: 130,
            maxWidth: 130,
        },
        {
            field: "updatedAt",
            headerName: formatMessage({ id: "content.grid.col.updatedAt" }),
            ...columnParForDates("updatedAt"),
            hide: true,
            maxWidth: 130,
            minWidth: 130,
        },
        {
            field: "deliveredAt",
            headerName: formatMessage({ id: "content.grid.col.deliveredAt" }),
            ...columnParForDates("deliveredAt"),
            maxWidth: 130,
            minWidth: 130,
        },
    ];
    return gridColumns;
}
